import axios from "axios";


const nomDeDomaine = window.location.hostname;
//const apiURL = "http://" + nomDeDomaine + ":8000/";
const apiURL = "http://back.relaitz.online/";

const apiClient = axios.create({
    baseURL: 'http://back.relaitz.online',
    headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer your_token'
    },
    withCredentials: true // If you need to send cookies with requests
});

export async function apiAxios(url, formdata = null, full = false) {
    const token = localStorage.getItem("token");
    const headers = {
        Token: token
    }
    let action = apiURL + url;
    if (full) action = url

    let response;
    if (formdata) {
        response = await axios.post(action, formdata, { headers: headers });
    }
    else {
        response = await axios.get(action, { headers: headers });
    }

    console.log(response.status);

    if (response.status == 200) {
        const json = await response.data;
        return json;
    }

    throw new Error(response.status);
}

export async function downloadFile(url, postData, fileName) {
    const token = localStorage.getItem("token");
    url = apiURL + url;
    const headers = {
        //Token: token,
        //responseType: 'arraybuffer'
        //'Content-Type': 'application/json',
    }
    try {
        const response = await axios(url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(postData),
        });

        if (!response.ok) {
            throw new Error('Erreur lors du téléchargement du fichier');
        }

        const blob = await response.blob();
        const urlBlob = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = urlBlob;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();

        window.URL.revokeObjectURL(urlBlob);
    } catch (error) {
        console.error('Erreur:', error);
    }
}

const url = 'https://example.com/download';
const postData = { key: 'value' }; // Les données à envoyer dans la requête POST
const fileName = 'fichier_telecharge.txt';

downloadFile(url, postData, fileName);


export async function download(url, formdata = null) {
    const token = localStorage.getItem("token");
    const headers = {
        Token: token,
        //responseType: 'arraybuffer'
    }
    let action = apiURL + url;
    let response;

    if (formdata) {
        response = await axios.post(action, formdata, { headers: headers });
    }
    else {
        response = await axios.get(action, { headers: headers });
    }

    if (response.status == 200) {
        //const fileData = Buffer.from(response.data, 'binary');
        console.log(response);
        /*const href = window.URL.createObjectURL(response.data);

        const anchorElement = document.createElement('a');

        anchorElement.href = href;
        anchorElement.download = "fichier.xlsx";

        document.body.appendChild(anchorElement);
        anchorElement.click();

        document.body.removeChild(anchorElement);
        window.URL.revokeObjectURL(href);*/
    }
    return;

}

export async function apiHTML(url) {
    const response = await axios.get(apiURL + url);
    if (response.status == 200) {
        const text = await response.data;
        return text;
        //return json.member ? json.member : json;
    }
}